import { definePreset } from '@primevue/themes';
import Lara from '@primevue/themes/lara';
import formField from '@/PrimeVue/themePreset/designTokens/formFieldDesignTokens';
import overlay from '@/PrimeVue/themePreset/designTokens/overlayDesignTokens';
import list from '@/PrimeVue/themePreset/designTokens/listDesignTokens';
import content from '@/PrimeVue/themePreset/designTokens/contentDesignTokens';
import autocomplete from '@/PrimeVue/themePreset/designTokens/autocompleteDesignTokens';
import datepicker from '@/PrimeVue/themePreset/designTokens/datepickerDesignTokens';
import listbox from '@/PrimeVue/themePreset/designTokens/listboxDesignTokens';
import tooltip from '@/PrimeVue/themePreset/designTokens/tooltipDesignTokens';

export default definePreset(Lara, {
  semantic: {
    colorScheme: {
      light: {
        formField,
        overlay,
        list,
        content
      }
    }
  },
  components: {
    autocomplete,
    datepicker,
    listbox,
    tooltip
  }
});